module.exports = __webpack_public_path__ + "static/media/external-link-square-alt.cff5de95.svg";